















































import Sortable from 'sortablejs';

import { UiIconButton } from './keen-ui';
import TransitionHeight from './transition-height.component.vue';

export default {
  name: 'mutable-list',
  props: {
    items: {
      type: Array,
      required: true
    },
    sortable: Boolean,
    sortGroupField: String,
    editable: Boolean,
    editedItemId: String,
    expandible: Boolean,
    expandedItemIds: {
      type: Array,
      default: () => []
    },
    removable: Boolean
  },
  components: {
    UiIconButton,
    TransitionHeight
  },
  computed: {
    iconButtonProps: function () {
      return {
        type: 'secondary',
        size: 'mini'
      };
    }
  },
  data: function () {
    return {
      sortableListObject: undefined
    };
  },
  methods: {
    isItemIdEdited: function (itemId: string): boolean {
      return (itemId === this.editedItemId);
    },
    isItemIdExpanded: function (itemId: string): boolean {
      return this.expandedItemIds.includes(itemId);
    }
  },
  mounted: function (): void {
    if (this.sortable) {
      this.sortableListObject = Sortable.create(this.$refs.list.$el, {
        handle: '.epb-mutable-list__icon-button--sort',
        ghostClass: 'epb-mutable-list__item--ghost',
        animation: 500,
        ...(!!this.sortGroupField && {
          onMove: (event) => {
            const draggedItem = this.items[Sortable.utils.index(event.dragged, '>*')];
            const targetItem = this.items[Sortable.utils.index(event.related, '>*')];
            return (draggedItem[this.sortGroupField] === targetItem[this.sortGroupField]);
          }
        }),
        onUpdate: (event) => {
          this.$emit('moveItem', { item: this.items[event.oldIndex], targetIndex: event.newIndex });
        }
      });
    }
  },
  beforeDestroy: function (): void {
    if (!!this.sortableListObject) {
      this.sortableListObject.destroy();
    }
  }
};
